import React, { Component } from 'react';

class KyusyuTop extends Component {
  render() {
    return (
      <div className="Kyusyu-top pref">
        <div>長崎</div>
        <div>佐賀</div>
        <div>福岡</div>
      </div>
    );
  }
}

class KyusyuMid extends Component {
  render() {
    return (
      <div className="Kyusyu-mid pref">
        <div>宮崎</div>
        <div>熊本</div>
        <div>大分</div>
      </div>
    );
  }
}

class KyusyuBot extends Component {
  render() {
    return (
      <div className="Kyusyu-bot pref">
        <div>沖縄</div>
        <div>鹿児島</div>
      </div>
    );
  }
}

class Kyusyu extends Component {

  render() {

    return (
      <div className="Kyusyu">
        <KyusyuTop />
        <KyusyuMid />
        <KyusyuBot />
      </div>
    );
  }

}

export default Kyusyu;
